<template>
  <div class="pagina">
    <div class="cabecera">
      <h1 class="titulo-pagina">Mis empresas</h1>
      <v-btn class="bg-blue boton-nueva" @click="openDialog = true">
        <v-icon size="20">mdi-plus</v-icon>
        <span class="texto-boton">Nueva empresa</span>
      </v-btn>
    </div>

    <!-- Cargando la LISTA de ids. Es una sola peticion liviana: cada tarjeta
         se encarga despues de sus propios datos y de su propia foto. -->
    <div v-if="cargandoLista" class="estado">
      <v-progress-circular indeterminate color="primary" size="34" width="3" />
      <span>Cargando tus empresas...</span>
    </div>

    <div v-else-if="errorLista" class="estado">
      <v-icon size="34" color="error">mdi-alert-circle-outline</v-icon>
      <span>No se pudieron cargar tus empresas</span>
      <v-btn class="bg-blue" @click="cargarLista">Reintentar</v-btn>
    </div>

    <div v-else-if="ids.length === 0" class="estado">
      <v-icon size="42" color="grey">mdi-store-outline</v-icon>
      <span>Todavia no tienes empresas registradas</span>
      <v-btn class="bg-blue" @click="openDialog = true">Crear la primera</v-btn>
    </div>

    <div v-else class="grilla">
      <TarjetaEdicionEmpresa
        v-for="id in ids"
        :key="id"
        :id-empresa="id"
      />
    </div>

    <v-dialog v-model="openDialog" max-width="600">
      <NewCompany
        @alRegistrarCorrectamente="addCompany"
        @onClose="openDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import apisCompanys from '@/apis/apisCompanys'
import apisUsers from '@/apis/apisUsers'
import NewCompany from '@/components/NewCompany.vue'
import TarjetaEdicionEmpresa from '@/components/TarjetaEdicionEmpresa.vue'

export default {
  name: 'MyCompanysView',
  components: { NewCompany, TarjetaEdicionEmpresa },
  data() {
    return {
      // Solo los ids: la vista no guarda los datos de las empresas, cada
      // tarjeta pide los suyos. Asi ninguna espera a las demas.
      ids: [],
      cargandoLista: true,
      errorLista: false,
      openDialog: false
    }
  },
  created() {
    apisUsers.isValid()
      .then(isValid => {
        if (isValid) {
          this.cargarLista()
        } else {
          this.$router.push('/')
        }
      })
      .catch(() => {
        this.$router.push('/')
      })
  },
  methods: {
    cargarLista() {
      this.cargandoLista = true
      this.errorLista = false

      apisCompanys.getMyCompanys()
        .then(empresas => {
          this.ids = empresas.map(e => e.idCompany)
        })
        .catch(() => {
          this.errorLista = true
        })
        .finally(() => {
          this.cargandoLista = false
        })
    },
    addCompany(empresa) {
      this.ids.push(empresa.idCompany)
      this.openDialog = false
    }
  }
}
</script>

<style scoped>
.pagina {
  max-width: 1240px;
  margin: 0 auto;
  padding: 16px 12px 32px;
}

.cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.titulo-pagina {
  font-size: 1.32rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}
.boton-nueva {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  gap: 6px;
}

/* Mobile first: una columna, y va abriendo columnas al crecer la pantalla */
.grilla {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
@media (min-width: 600px) {
  .grilla {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 960px) {
  .grilla {
    grid-template-columns: repeat(3, 1fr);
  }
}

.estado {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 56px 16px;
  color: #667085;
  font-size: 0.92rem;
  text-align: center;
}

/* En pantallas muy chicas el boton se queda solo con el icono */
@media (max-width: 400px) {
  .texto-boton {
    display: none;
  }
}
</style>
